module.exports = __webpack_public_path__ + "static/media/400141_01.7815d4a3.png";